<template>
  <div v-if="params.recalculation" :class="$style.container">
    <fragment v-if="!list">
      Все
    </fragment>
    <fragment v-else-if="list.length <= 2">
      <div :class="$style.text">
        {{ list.join(', ') }}
      </div>
    </fragment>
    <fragment v-else>
      <div :class="$style.text">
        {{ list.join(', ') }}
      </div>
      <div :class="$style.total">
        ({{ list.length }})
      </div>
      <vs-button
        :class="$style.button"
        size="small"
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-info"
        @click="onOpenList"
      />
    </fragment>
  </div>
</template>

<script>
import Vue             from 'vue';
import notifyHttpError from "@/mixins/notifyHttpError";

export default Vue.extend({
  name:     "RecalculationAccounts",
  mixins:   [notifyHttpError],
  computed: {
    list() {
      const { recalculation } = this.params;
      if (!recalculation) return null;
      return recalculation.list ? recalculation.list.split(',') : null;
    },
  },
  methods:  {
    onOpenList() {
      this.$modal.open({
        size:           'xs',
        title:          'Лицевые счета',
        component:      () => import('@/components/calculated-program/recalculations/RecalculationAccountsModal'),
        componentProps: { accounts: this.list },
      });
    },
  },
});
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.button {
  flex-shrink: 0;
  margin-left: 5px;
}
</style>
